import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthData } from '../models/auth-data.model';
import { UserCreds } from '../models/user-creds.model';

@Injectable()
export class AuthService {
    protected user: UserCreds;

    constructor(protected router: Router) { }

    public RegisterUser(authData: AuthData) {
        this.user = {
            email: authData.email,
            userId: Math.round(Math.random() * 10000).toString(),
            password: authData.password
        };
        this.authSuccessfully();
    }

    public Login(authData: AuthData) {
        this.user = {
            email: authData.email,
            userId: Math.round(Math.random() * 10000).toString(),
            password: authData.password
        };
        this.authSuccessfully();
    }

    public Logout() {
        this.user = null;
        this.router.navigate(['/login']);
    }

    public GetUser() {
        return { ...this.user };
    }

    public IsAuth() {
        return this.user !== null && this.user !== undefined;
    }

    protected authSuccessfully() {
        this.router.navigate(['/admin']);

        // window.location.replace('https://ambl-on.fathym-int.com/admin/home');
    }
}
